// 隐藏的功能性路由
const routes = {
  path: '/',
  component: () => import('@/components/layout/index.vue'),
  alwaysShow: true,
  hidden: true,
  meta: {
    title: '企业管理',
    permission: 'company',
    icon: 'iconqiyeguanli'
  },
  children: [
    {
      path: 'workspace/search/quickly-result',
      name: 'QuicklyResult',
      component: () => import('@/views/workspace/globalSearch/quicklyResult.vue'),
      meta: {
        title: '快捷搜索'
      },
      hidden: true
    },
    {
      path: 'approve-manager/report/list',
      name: 'ApproveReport',
      component: () => import('@/views/workFlow/approve/report/index'),
      hidden: true,
      meta: {
        title: '报备审批',
        icon: 'iconshenpi',
        voucher_type: 6,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/look/list',
      name: 'ApproveLook',
      component: () => import('@/views/workFlow/approve/look/index'),
      hidden: true,
      meta: {
        title: '带看审批',
        icon: 'icondaikan',
        voucher_type: 7,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/recognition/list',
      name: 'ApproveRecognition',
      component: () => import('@/views/workFlow/approve/recognition/index'),
      hidden: true,
      meta: {
        title: '认筹审批',
        icon: 'iconshoujubuda_renchou',
        voucher_type: 8,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/subscribe/list',
      name: 'ApproveSubscribe',
      component: () => import('@/views/workFlow/approve/subscribe/index'),
      hidden: true,
      meta: {
        title: '认购审批',
        icon: 'iconrengou',
        voucher_type: 9,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/sign/list',
      name: 'ApproveSign',
      component: () => import('@/views/workFlow/approve/signing/index'),
      hidden: true,
      meta: {
        title: '签约审批',
        icon: 'iconqianyue',
        voucher_type: 10,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/settlement/list', 
      name: 'ApproveSettlement',
      component: () => import('@/views/workFlow/approve/settlement/index'),
      hidden: true,
      meta: {
        title: '结佣审批',
        icon: 'iconyongjin',
        voucher_type: 11,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/refund/list',
      name: 'ApproveRefund',
      component: () => import('@/views/workFlow/approve/refund/index'),
      hidden: true,
      meta: {
        title: '退款审批',
        icon: 'icontuikuan',
        voucher_type: 12,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/lock/list',
      name: 'ApproveLock',
      component: () => import('@/views/workFlow/approve/lock/index'),
      hidden: true,
      meta: {
        title: '锁定审批',
        icon: 'iconsuoding',
        voucher_type: 1,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/collision/list',
      name: 'ApproveCollision',
      component: () => import('@/views/workFlow/approve/collision/index'),
      hidden: true,
      meta: {
        title: '撞客审批',
        icon: 'iconkehu1',
        voucher_type: 2,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/merge/list',
      name: 'ApproveMerge',
      component: () => import('@/views/workFlow/approve/merge/index'),
      hidden: true,
      meta: {
        title: '合并审批',
        icon: 'iconhebing',
        voucher_type: 3,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/invalid/list',
      name: 'ApproveInvalid',
      component: () => import('@/views/workFlow/approve/invalid/index'),
      hidden: true,
      meta: {
        title: '无效审批',
        icon: 'iconwuxiao',
        voucher_type: 4,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/black/list',
      name: 'ApproveBlack',
      component: () => import('@/views/workFlow/approve/black/index'),
      hidden: true,
      meta: {
        title: '黑名单审批',
        icon: 'iconheimingdan',
        voucher_type: 5,
        isHideBread: true
      }
    },
    {
      path: 'approve-manager/helper/list',
      name: 'ApproveHelper',
      component: () => import('@/views/workFlow/approve/helper/index'),
      hidden: true,
      meta: {
        title: '协助人审批',
        icon: 'iconheimingdan',
        voucher_type: 13,
        isHideBread: true
      }
    },
  ]
}
export default routes;